import React from 'react'
import { Navbar } from '../../components/index.js'
import './header.css'

const Header = () => {
  return (
    <Navbar></Navbar>
  )
}

export default Header
